import LoaderOverlay from "@edaz/edazkit/LoaderOverlay/index";
import { observer } from "mobx-react-lite";
import React from "react";
import Modal from "react-bootstrap/Modal";
import type { ViewComponent } from "@frui.ts/views/dist";
import { preventDefault, View } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import Button from "@edaz/edazkit/Button/index";
import { Form, Col } from "react-bootstrap";
import FormLabel from "controls/formLabel";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import RoleUserCreateViewModel from "viewModels/users/roles/detail/roleUserCreateViewModel";

export const RoleUserCreateView: ViewComponent<RoleUserCreateViewModel> = observer(({ vm }) => {
  return (
    <Modal show={vm.showModal} centered>
      <Modal.Header>
        <Modal.Title>{vm.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <View vm={vm.alertsViewModel} useLifecycle={true} />
        <LoaderOverlay loading={vm.busyWatcher.isBusy}>
          <Form onSubmit={preventDefault(vm.save)}>
            <Form.Row className="mb-1">
              <Form.Group as={Col} md={12} target={vm.item} property="id">
                <FormLabel>{vm.translate("id")}</FormLabel>
                <AdvancedSelect items={vm.userOptions} target={vm.item} property="id" />
              </Form.Group>
            </Form.Row>
            <ButtonToolbar className="justify-content-center">
              <Button size="sm" type="reset" onClick={vm.onClose} variant="light">
                {vm.translateGeneral("cancel")}
              </Button>
              <Button size="sm" type="submit" disabled={vm.busyWatcher.isBusy}>
                {vm.translateGeneral("save")}
              </Button>
            </ButtonToolbar>
          </Form>
        </LoaderOverlay>
      </Modal.Body>
    </Modal>
  );
});

registerView(RoleUserCreateView, RoleUserCreateViewModel);
